import cookies from 'browser-cookies'

export const setServerFriendlyCookie = (key: string, value: string) => {
  cookies.set(key, Buffer.from(JSON.stringify({ message: value })).toString('base64'))
}

export const getServerFriendlyCookieValue = (key: string): string | undefined => {
  return JSON.parse(Buffer.from(cookies.get(key), 'base64').toString())?.message
}
